import { render, staticRenderFns } from "./YetkiTanimla.vue?vue&type=template&id=5fe9c220&"
import script from "./YetkiTanimla.vue?vue&type=script&lang=js&"
export * from "./YetkiTanimla.vue?vue&type=script&lang=js&"
import style0 from "./YetkiTanimla.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports